import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Lock, Mail, Sparkles } from 'lucide-react';
import { adminClient, saveToken } from './adminApi';

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!email.trim() || !password.trim() || submitting) return;
    setSubmitting(true);
    setError('');
    try {
      const { data } = await adminClient.post('/auth/login', {
        email: email.trim().toLowerCase(),
        password,
      });
      saveToken(data.access_token);
      navigate('/admin', { replace: true });
    } catch (err) {
      const detail = err?.response?.data?.detail;
      setError(typeof detail === 'string' ? detail : 'Invalid email or password');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <section
      data-testid="admin-login-screen"
      className="min-h-screen flex items-center justify-center px-5"
    >
      <div className="w-full max-w-[420px] mx-auto text-center">
        <div
          className="mx-auto mb-6 inline-flex items-center justify-center rounded-full"
          style={{
            width: 72, height: 72, backgroundColor: '#3D3830',
            boxShadow: '0 18px 50px -22px rgba(158,140,168,0.6)',
          }}
        >
          <Sparkles size={28} strokeWidth={1.4} color="#FFFFFF" />
        </div>
        <p className="section-label mb-2">Admin Panel</p>
        <h1
          data-testid="admin-login-title"
          className="font-heading text-[36px] sm:text-[44px] leading-[1.1]"
          style={{ fontWeight: 500, color: '#3D3830' }}
        >
          Welcome back
        </h1>
        <p className="font-body text-[14px] mt-3" style={{ color: '#6d655a' }}>
          Sign in to view and export your quiz leads.
        </p>

        <form onSubmit={onSubmit} className="mt-8 flex flex-col gap-3 text-left" data-testid="admin-login-form">
          <label className="relative">
            <Mail size={16} strokeWidth={1.5} className="absolute left-4 top-1/2 -translate-y-1/2" style={{ color: '#3D3830' }} />
            <input
              data-testid="admin-email-input"
              type="email"
              autoComplete="email"
              placeholder="you@karamears.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="form-input"
              style={{ paddingLeft: 42 }}
              required
            />
          </label>
          <label className="relative">
            <Lock size={16} strokeWidth={1.5} className="absolute left-4 top-1/2 -translate-y-1/2" style={{ color: '#3D3830' }} />
            <input
              data-testid="admin-password-input"
              type="password"
              autoComplete="current-password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="form-input"
              style={{ paddingLeft: 42 }}
              required
            />
          </label>
          {error && (
            <p data-testid="admin-login-error" className="font-body text-[13px]" style={{ color: '#B14B4B' }}>
              {error}
            </p>
          )}
          <button
            data-testid="admin-login-submit"
            type="submit"
            disabled={submitting}
            className="btn-primary mt-2"
          >
            {submitting ? 'Signing in…' : 'Sign in'}
          </button>
        </form>

        <p className="font-body text-[12px] mt-8" style={{ color: '#3D3830', letterSpacing: '0.18em', textTransform: 'uppercase' }}>
          Kara Mears Midwifery
        </p>
      </div>
    </section>
  );
}
